import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import STree from "@/components/Tree/STree";
import identityIcon from "@/libs/identityIcon";
import OrgUserTagSelectList from "@/components/FragmentTemplate/OrgUserTagSelectList";
export default {
  name: "ChangeOrgUser",
  components: {
    STree,
    OrgUserTagSelectList
  },
  props: {
    scopeList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      modal: {
        visible: false,
        loading: false
      },
      dataTree: [],
      checkTree: [],
      identityIcon
    };
  },
  methods: {
    open() {
      this.modal.visible = true;
      this.setValue();
    },
    /* 不显示弹窗 */
    clean() {
      this.checkTree = [];
      this.dataTree = [];
      this.modal.visible = false;
    },
    setValue() {
      this.checkTree = [...this.scopeList];
    },
    async onCommit() {
      this.$emit("change", this.checkTree);
      this.clean();
    },
    onSelectChangeTree(item) {
      if (this.checkTree.findIndex(v => v.orgId === item.orgId) === -1) {
        item.isCheck = true;
        this.checkTree.push(item);
      } else {
        this.$Message.warning($t("e7dxe3", "已存在"));
      }
    },
    onDelete(item) {
      let index = this.checkTree.findIndex(v => v.orgId === item.orgId);
      if (index > -1) {
        item.isCheck = false;
        this.checkTree.splice(index, 1);
      }
    },
    /*
     ** 递归
     */
    echoCheckDG(data) {
      let change = arr => {
        arr.forEach(v => {
          this.echoCheck(v);
          let children = v.children;
          if (children && children.length > 0) {
            change(children);
          }
        });
      };
      change(data);
    },
    /*
     ** 设置已勾选部门或者成员
     */
    echoCheck(item) {
      let checkTree = this.checkTree;
      let index = checkTree.findIndex(v => {
        return v.orgId === item.orgId;
      });
      if (index > -1) {
        item.isCheck = true;
        checkTree[index] = item;
        this.checkTree = [...checkTree];
      }
    }
  }
};